const agentsSocietyDomains: string[] = [
  'agents-society.com',
  'agents-society-demo.com',
  'agents-society-dev.com',
  'agents-society-dev-gk.com',
  'agents-society-dev-vidic.com',
  'agents-society-dev-usyk.com',
  'agents-society-dev-khan.com',
  'agents-society-preprod.com',
  'agents-society-sandbox.com',
  'agents-society-stage.com',
  'agents-society-test.com',
  'agents-society.test',
];

const katoDomains: string[] = ['kato.app', 'kato.test', 'jllsandbox.kato.rocks', 'jllsandbox.kato-sandbox.app'];

const katoDevWildcardDomains: string[] = ['katodev.uk'];

interface HostConfig {
  domain: string;
  isAgentsSociety: boolean;
  isAgency: boolean;
  isKato: boolean;
  isLandlord: boolean;
}

export const getHostConfig = (hostname?: string): HostConfig => {
  const host = hostname || window.location.hostname;

  const agentsSocietyDomain = agentsSocietyDomains.find((domain) => host.endsWith(domain)) || '';
  const katoDomain = katoDomains.find((domain) => host.endsWith(domain)) || '';

  let katoDevWildcardDomain = '';
  if (!agentsSocietyDomain && !katoDomain) {
    const matchedBase = katoDevWildcardDomains.find((domain) => host.endsWith(domain));
    if (matchedBase) {
      const parts = host.split('.');
      const basePartCount = matchedBase.split('.').length;
      if (parts.length > basePartCount + 1) {
        katoDevWildcardDomain = parts.slice(-(basePartCount + 1)).join('.');
      }
    }
  }

  const domain = agentsSocietyDomain || katoDomain || katoDevWildcardDomain;

  if (!domain) {
    throw new Error(`"${host}" is not a valid domain`);
  }

  const result: HostConfig = {
    domain,
    isAgentsSociety: !!agentsSocietyDomain,
    isKato: !!katoDomain || !!katoDevWildcardDomain,
    isAgency: host.startsWith('app.') || host.startsWith('os.'), // app. is @deprecated
    isLandlord: host.startsWith('landlord.'),
  };

  return result;
};

interface BaseUrlConfig {
  atlasRoot: string;
  agencyRoot: string;
  agencyApi: string;
  landlordRoot: string;
  landlordApi: string;
  developerRoot: string;
  developerApi: string;
  commonRoot: string;
  commonApi: string;
}

export const getBaseUrlConfig = (hostname?: string) => {
  const hostConfig = getHostConfig(hostname);

  let agencyRoot = `https://agency.${hostConfig.domain}`;
  let agencyApi = `https://agency.${hostConfig.domain}/api`;
  let landlordRoot = `https://landlord.${hostConfig.domain}`;
  let landlordApi = `https://landlord.${hostConfig.domain}/api`;
  const atlasRoot = `https://atlas.${hostConfig.domain}`;
  const developerRoot = `https://developer.${hostConfig.domain}`;
  const developerApi = `https://developer.${hostConfig.domain}/api`;

  // @deprecated
  if (hostConfig.isAgentsSociety) {
    agencyRoot = `https://${hostConfig.domain}`;
    agencyApi = `https://${hostConfig.domain}/api`;
    landlordRoot = `https://landlord.${hostConfig.domain}`;
    landlordApi = `https://landlord.${hostConfig.domain}/api`;
  }

  const result: BaseUrlConfig = {
    atlasRoot,
    agencyRoot,
    agencyApi,
    landlordRoot,
    landlordApi,
    developerRoot,
    developerApi,
    commonRoot: hostConfig.isLandlord ? landlordRoot : agencyRoot,
    commonApi: hostConfig.isLandlord ? landlordApi : agencyApi,
  };

  return result;
};

export const getBaseUrl = (subDomain?: string, hostname?: string) => {
  if (subDomain) {
    return `https://${subDomain}.${getHostConfig(hostname).domain}/`;
  }

  return getBaseUrlConfig(hostname).agencyRoot + '/';
};
